import React from "react"
import { Link } from 'gatsby'
import Hub from "../../components/layouts/Hub"

export default ({ children }) => {
  return (
    <Hub links={[
      <Link to="/sequence-diagram">Builder</Link>,
      <Link to="/sequence-diagram/learn">Tutorial</Link>,
      <Link to="/sequence-diagram/documentation">Doc</Link>,
    ]}>
      {children}
    </Hub>
  )
}
